module.exports = "<p style=\"font-weight: bold;margin-left: 20%;\">\n  Page under construction.\n  <br>\n  Orders will be displayed here.\n<br>\n  <a [routerLink]=\"['/buyer/request-for-quotations']\">Go to RFQs</a>\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/buyer/orders/orders.component.html
// module id = 549
// module chunks = 0